import { Heading, ProgressBar, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { captionsViewBlock as block } from '../utils';
import { useCaptionsChildViewContext } from './CaptionsChildViewContext';

export type CaptionsChildViewTranscriptionProgressProps = {};

const CaptionsChildViewTranscriptionProgress: React.FC<CaptionsChildViewTranscriptionProgressProps> = () => {
  const {
    media,
    isLoadingMediaInfo,
    transcribingProgress,
  } = useCaptionsChildViewContext();

  return (
    <Spacer
      space="2px"
      orientation="vertical"
      align="flex-start"
      justify="space-between"
      className={block('transcription-progress-container')}
    >
      <Heading level={2} className={block('transcribing-label')}>
        {media.type === 'video' && isLoadingMediaInfo
          ? 'Uploading video'
          : 'Still processing'}
      </Heading>

      <ProgressBar
        value={isLoadingMediaInfo ? undefined : transcribingProgress}
        isIndeterminate={isLoadingMediaInfo}
        trackClassName={block('caption-progress-track')}
      />
    </Spacer>
  );
};

export default CaptionsChildViewTranscriptionProgress;
